export type OfferMode = "trial" | "discount";
export type UserIntentSegment = "cold_user" | "high_intent_returner";

export interface ConversationStatsSnapshot {
  sessions?: number;
  sessionsThisWeek?: number;
  totalMessages?: number;
  lastActivityAt?: string | null;
}

function daysSince(isoDate: string | null | undefined): number {
  if (!isoDate) return Number.POSITIVE_INFINITY;
  const ts = Date.parse(isoDate);
  if (!Number.isFinite(ts)) return Number.POSITIVE_INFINITY;
  return Math.floor((Date.now() - ts) / (1000 * 60 * 60 * 24));
}

export function classifyUserIntentFromStats(stats: ConversationStatsSnapshot): UserIntentSegment {
  const sessions = stats.sessions ?? 0;
  const sessionsThisWeek = stats.sessionsThisWeek ?? 0;
  const totalMessages = stats.totalMessages ?? 0;
  const daysSinceLastActivity = daysSince(stats.lastActivityAt);

  const isHighIntent =
    sessions >= 5 ||
    (sessions >= 3 && sessionsThisWeek >= 1) ||
    (sessions >= 2 && totalMessages >= 20 && daysSinceLastActivity <= 7);

  return isHighIntent ? "high_intent_returner" : "cold_user";
}

export function recommendedOfferModeForSegment(segment: UserIntentSegment): OfferMode {
  return segment === "high_intent_returner" ? "discount" : "trial";
}
